module.exports = __webpack_public_path__ + "img/Knitting.d9b73132.jpg";